var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_dom-create.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_dom-create.js
// module chunks = 168707334958949